import React, { forwardRef } from 'react';
import './Input.scss';

export interface InputProps {
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url';
  placeholder?: string;
  value?: string | number;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  disabled?: boolean;
  error?: string;
  label?: string;
  required?: boolean;
  className?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  autoComplete?: string;
  name?: string;
  id?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = 'text',
      placeholder,
      value = '',
      onChange,
      onBlur,
      onFocus,
      disabled = false,
      error,
      label,
      required = false,
      className = '',
      fullWidth = false,
      size = 'medium',
      autoComplete,
      name,
      id,
    },
    ref
  ) => {
    const baseClass = 'ui-input';
    const sizeClass = `${baseClass}--${size}`;
    const errorClass = error ? `${baseClass}--error` : '';
    const widthClass = fullWidth ? `${baseClass}--full-width` : '';

    const inputClass = [baseClass, sizeClass, errorClass, widthClass, className]
      .filter(Boolean)
      .join(' ');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value);
    };

    return (
      <div className={`${baseClass}-wrapper`}>
        {label && (
          <label className={`${baseClass}-label`} htmlFor={id}>
            {label}
            {required && <span className={`${baseClass}-required`}>*</span>}
          </label>
        )}
        <input
          ref={ref}
          type={type}
          className={inputClass}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={disabled}
          required={required}
          autoComplete={autoComplete}
          name={name}
          id={id}
        />
        {error && <div className={`${baseClass}-error`}>{error}</div>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
